import { Component, Input, ViewChild } from '@angular/core';
import { SettlementsService } from 'src/app/services/settlements.service';
import { ngxCsv } from 'ngx-csv';
import * as bs from 'bootstrap';
import * as xml2js from 'xml2js';
import { IconsService } from 'src/app/shared/services/icons.service';
import { ModalInvoicesIngresoComponent } from './modal-invoices-ingreso.component';


@Component({
  selector: 'app-report-invoices-ingreso',
  template: `
    <button type="button" class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4" (click)="modalReport()">
      Ingresos
    </button>
    <app-modal-invoices-ingreso
      [profile]="profile" 
      [loading]="loading" 
      (createReport)="generateReport($event)"
    ></app-modal-invoices-ingreso>
  `,
  styles: [
  ]
})
export class ReportInvoicesIngresoComponent {
  @Input() profile: any;
  @ViewChild(ModalInvoicesIngresoComponent, { static: false }) modalInvoicesIngreso!: ModalInvoicesIngresoComponent;

  loading: boolean = false;

  payload: any = {
    page: 1,
    per_page: 100000,
    tipo: 0,
    canceled: false,
    created_at_since: '',
    created_at_to: '',
    sort: 'created_at',
    order: 'DESC'
  };

  constructor(
    private store: SettlementsService,
    public icons: IconsService
  ) { }

  modalReport() {
    // const modalTemplate: any | undefined = this.modalInvoicesIngreso;
    // console.log('modalTemplate => ', modalTemplate);
    // if (modalTemplate) {
      // this.modalInvoicesIngreso.openModal(modalTemplate['modalInvoicesIngreso']);
    // }
    new bs.Modal(<HTMLInputElement>document.getElementById('modalInvoicesIngreso')).show();
  }

  generateReport(data: any) {
    this.loading = true;
    this.payload.created_at_since = data.created_at_since;
    this.payload.created_at_to = data.created_at_to;
    this.payload.profile_id = this.profile.id;
    this.store.getInvoicesQuery(this.payload).subscribe(async (res: any) => {
      let report: any[] = [];
      await res.data.map(async (invoice: any) => {
        const parser = new xml2js.Parser({
          trim: true,
          explicitArray: true,
        });
        await parser.parseString(invoice.cfdixml, (err: any, result: any) => {
          // console.log('result => ', result);
          // console.log('receptor ==> ', result['cfdi:Comprobante']['cfdi:Receptor'][0]['$']);
          // console.log('WAIT ====> ', result['cfdi:Comprobante']);
          const main = result['cfdi:Comprobante']['$'];
          const receptor = result['cfdi:Comprobante']['cfdi:Receptor'][0]['$'];
          const complemento = result['cfdi:Comprobante']['cfdi:Complemento'][0]['tfd:TimbreFiscalDigital'][0]['$'];

          report.push({
            serie: main['Serie'],
            folio: main['Folio'],
            fecha: main['Fecha'],
            uuid: complemento['UUID'],
            rfc: receptor['Rfc'],
            razon: receptor['Nombre'],
            subTotal: main['SubTotal'],
            total: main['Total'],
          });
        });
      });

      console.log('REPORT BUILT ===> ', report);
      let options = {
        title: 'Reporte de facturas de ingresos',
        headers: ['Serie', 'Folio', 'Fecha', 'Folio fiscal', 'RFC receptor', 'Razón social', 'Subtotal', 'Total'],
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalseparator: '.',
        showLabels: true,
        showTitle: true,
        useBom: true,
      };

      new ngxCsv(report, `reporte_factuas_ingresos`, options);
      this.loading = false;
    });
  }

}
